import { useFetchFromHarvestApp as fetch } from './useApi'

export default function (params) {
  const { result, error, loading, refetch } = fetch(
    '/platform?' + new URLSearchParams(params).toString()
  )

  let data = null

  if (result) {
    const {
      external_reference: { total_hours: totalHours, icon_url: iconUrl },
      create_project_url: createProjectUrl,
      user: {
        can_switch_accounts: canSwitchAccounts,
        can_create_projects: canCreateProjects,
        can_read_all_cost_rates: canReadAllCostRates,
      },
      integrations: {
        asana: {
          enabled: asanaEnabled,
          auto_sync_enabled: asanaAutoSyncEnabled,
          enable_auto_sync_url: enableAutoSyncUrl,
        },
      },
      data_layer: dataLayer,
      suggested_project_id: suggestedProjectId,
      suggested_task_id: suggestedTaskId,
      timesheet_approved: timesheetApproved,
      day_entry_notes_required: dayEntryNotesRequired,
    } = result

    data = {
      externalReference: {
        totalHours,
        iconUrl,
      },
      user: {
        canSwitchAccounts,
        canCreateProjects,
        canReadAllCostRates,
      },
      integrations: {
        asana: {
          enabled: asanaEnabled,
          autoSyncEnabled: asanaAutoSyncEnabled,
          enableAutoSyncUrl,
        },
      },
      createProjectUrl,
      dataLayer,
      suggestedProjectId,
      suggestedTaskId,
      timesheetApproved,
      dayEntryNotesRequired,
    }
  }

  return { data, error, loading, refetch }
}
